require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-the-santa-rita-case-tests-ifcs-new-remedy-and-resp.json") })
        }
      }, "path---en-us-update-the-santa-rita-case-tests-ifcs-new-remedy-and-resp");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-the-santa-rita-case-tests-ifcs-new-remedy-and-resp!./.cache/json/en-us-update-the-santa-rita-case-tests-ifcs-new-remedy-and-resp.json
// module id = 806
// module chunks = 231608221292675